module.exports = __webpack_public_path__ + "static/media/fort-awesome-alt.bd2abd9b.svg";